import { render, staticRenderFns } from "./accessPage.vue?vue&type=template&id=5935f93f&"
import script from "./accessPage.vue?vue&type=script&lang=js&"
export * from "./accessPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports